if (!customElements.get('br-business-details')) {
  customElements.define('br-business-details', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const form = document.getElementById('cart-form');
      if (!form) return;
      form.addEventListener('submit', async (event) => {
        if (this.allowSubmit) return;
        const submitter = event.submitter;
        const isCheckout = submitter?.name === 'checkout';
        const isBusinessSave = submitter?.hasAttribute('data-save-business-details');
        if (!isCheckout && !isBusinessSave) return;
        event.preventDefault();
        if (this.saving) return;
        this.saving = true;
        const status = this.querySelector('[data-business-status]');
        const fields = Array.from(this.querySelectorAll('input[name^="attributes["]'));
        const attributes = Object.fromEntries(fields.map(input => [input.name.slice(11, -1), input.value.trim()]));
        status.textContent = 'Ukládáme firemní údaje…';
        try {
          const response = await fetch(this.dataset.updateUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ attributes }),
          });
          if (!response.ok) throw new Error('Cart update failed');
          const cart = await response.json();
          if (Object.entries(attributes).some(([key, value]) => (cart.attributes?.[key] || '') !== value)) {
            throw new Error('Cart attributes were not saved');
          }
          fields.forEach(input => { input.value = attributes[input.name.slice(11, -1)]; });
          status.textContent = Object.values(attributes).some(Boolean) ? 'Firemní údaje jsou uložené.' : 'Firemní údaje byly vymazány.';
          if (isCheckout) {
            this.allowSubmit = true;
            form.requestSubmit(submitter);
          }
        } catch (_) {
          status.textContent = 'Údaje se nepodařilo uložit. Zkuste to prosím znovu před pokračováním k platbě.';
        } finally {
          this.saving = false;
        }
      }, { signal: this.controller.signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
